import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';

// Item 3040956373 (DETTE-FE-DATA) — textarea de commentaire/motif partagé (DRY).
// Factorise le duo <textarea> + avertissement RGPD `privacy.commentsDisclaimer`
// dupliqué sur 5 call-sites (guided-entry, export preview, rectify/reopen FY,
// versioning facteur RGPD-4.9 change_reason).
//
// Remplacement TRANSPARENT : le style de chaque textarea reste piloté par le
// call-site via `className` (les modales ont des accents distincts — anneau de
// focus bleu/orange, radius/padding propres — qu'il ne faut PAS uniformiser).
// Le composant ne possède QUE l'avertissement RGPD, seul élément réellement
// commun. Le label reste au call-site (styles hétérogènes selon le contexte).
//
// Props :
//   value, onChange        — pilotés par le parent (onChange reçoit l'event natif)
//   onBlur                 — optionnel (export preview persiste au blur)
//   placeholder, rows      — passthrough textarea
//   className              — classes Tailwind EXACTES du call-site (style préservé)
//   showDisclaimer=true    — affiche l'avertissement RGPD (false : reopen FY, sans)
//   disclaimerClassName    — override du style de l'avertissement (variante export)
//   ...rest                — data-testid, id, name, disabled, aria-* → sur le textarea
export function CommentTextarea({
  value,
  onChange,
  onBlur,
  placeholder,
  rows,
  className,
  showDisclaimer = true,
  disclaimerClassName,
  ...rest
}) {
  const { isDark } = useTheme();
  const { t } = useLanguage();

  return (
    <>
      <textarea
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        rows={rows}
        className={className}
        {...rest}
      />
      {showDisclaimer && (
        <p
          className={
            disclaimerClassName ??
            `text-xs italic mt-1 ${isDark ? 'text-slate-500' : 'text-gray-400'}`
          }
        >
          {t('privacy.commentsDisclaimer')}
        </p>
      )}
    </>
  );
}
